import { computed } from "vue";

/**
 * True when the SPA is running locally (DEV build or hostname is
 * `localhost` / `127.0.0.1`).
 *
 * Returns false when `VITE_SIMULATE_PROD=true` is set in the environment so
 * docs-screenshot captures show production chrome (blue app bar, blue mobile
 * meeting nav bar, no "DEV" suffix in the document title).
 *
 * Single source of truth for env-tinted UI — `MainLayout`, `MeetingView`, and
 * `useDocumentTitle` all read from here so a future component that hard-codes
 * `bg-warning` against its own copy of this check is the regression, not the
 * default. A new env-tinted surface must also be added to `DEV_TINTED_SURFACES`
 * in `frontend/tests/screenshots/utils/screenshot-helper.ts`, whose guard fails
 * a docs capture when one of those surfaces is amber. That guard deliberately
 * does not look for `.bg-warning` anywhere on the page: ordinary product UI
 * uses warning colour for real content, and treating that as dev chrome
 * blocked seven docs screenshots.
 */
export function useIsLocalEnv() {
  const isLocalEnv = computed(() => {
    if (import.meta.env.VITE_SIMULATE_PROD === "true") return false;
    if (import.meta.env.DEV) return true;
    if (typeof window !== "undefined") {
      const host = window.location.hostname;
      return host === "localhost" || host === "127.0.0.1";
    }
    return false;
  });
  return { isLocalEnv };
}
